import styled from "styled-components";

export const OptionLabel = styled.span`

`;
export const OptionCount = styled.span`
margin-left: 5px;
  font-size: 11px;
`;